import { render, staticRenderFns } from "./StatsCalendar.vue?vue&type=template&id=0fd9a60a&scoped=true&"
import script from "./StatsCalendar.vue?vue&type=script&lang=js&"
export * from "./StatsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9a60a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd9a60a')) {
      api.createRecord('0fd9a60a', component.options)
    } else {
      api.reload('0fd9a60a', component.options)
    }
    module.hot.accept("./StatsCalendar.vue?vue&type=template&id=0fd9a60a&scoped=true&", function () {
      api.rerender('0fd9a60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/Includes/StatsCalendar.vue"
export default component.exports